<template>
  <div class="navbar">
    <div class="right-menu spaceLeft">
      <div class="right-menu_account">Account: {{ userInfo.username || getUserName() }}</div>
      <svg-icon class="right-menu_svg" icon-class="tn-logout" @click="logout"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    async logout() {
      this.$confirm("Are you sure you want to log out and exit?", "Tips", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      }).then(() => {
        this.$store.dispatch("LogOut").then(() => {
          location.reload();
        });
      });
    },
    getUserName(){
      if(this.$store.getters.userInfo.type == 1){ //AUDIT MANAGER
        return process.env.VUE_APP_AUDIT_MANAGER;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 64px;
  overflow: hidden;
  position: relative;
  background: #143c96;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  color: #fff;
  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    .right-menu_account,
    .right-menu_svg {
      font-size: 0.18rem;
      margin-right: 0.32rem;
    }
    .right-menu_svg {
      cursor: pointer;
    }

    &:focus {
      outline: none;
    }
  }
}
</style>
